<div class="tag-bulk-container">
  <form [formGroup]="formGroup">
    <div class="p-grid p-fluid ">
      <div class="p-col-6 p-md-6 p-lg-6">
        <div class="label-block">
          <form-factory [formGroup]="formGroup" [model]="tagNotes"></form-factory>
        </div>
      </div>
    </div>
    <div class="p-grid p-fluid">
      <div class="p-col-12 p-md-12 p-lg-12">
        <app-button text="CONTINUE TO VALIDATION" (onClick)="validateToShowTagGrid()"></app-button>
      </div>
    </div>
  </form>


  <div class="ui-g ui-fluid" *ngIf="isShowValidateGridData && !isDurableJobQueued">
    <div class="ui-g-12 ui-md-12 ui-lg-12">
      <app-basic-grid [configuration]="serverGridConfiguration"
                       [data]="data">
      </app-basic-grid>
    </div>
    <div class="p-grid p-fluid"><app-button (onClick)="finalBulkUpdate()" text="FINISH BULK UPDATE" [disabled]="isFinalBulkUpdate"></app-button></div>
  </div>

  <div class="bulk-update-tag__notice" *ngIf="isDurableJobQueued">
    <app-icon iconName="info-circle" class="bulk-update-tag__notice-icon"></app-icon>
    <div>
      <div class="bulk-update-tag__notice-title bold">Bulk action submitted</div>
      <div>
        This bulk change involves a large number of chases, so it's being validated in the
        background. You'll receive a notification when validation finishes &mdash; open it to
        review the results and continue.
      </div>
    </div>
  </div>

</div>
